import { colors } from 'theme';
import { ButtonProps, Tooltip } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import ConditionalWrapper from 'components/ConditionalWrapper';
import HollowButton from '../box44/components/HollowButton';

interface Props extends ButtonProps {
    compact?: boolean;
    condensed?: boolean;
    title?: string;
}

const SearchCustomerButton = ({ compact, condensed, title, icon, ...buttonProps }: Props) => {
    return (
        <ConditionalWrapper
            condition={compact}
            wrapper={(children) => <Tooltip title={title ?? 'Search Customer'}>{children}</Tooltip>}
        >
            <HollowButton
                {...buttonProps}
                type={condensed ? undefined : 'primary'}
                shape={compact ? 'circle' : 'default'}
                onClick={(e) => {
                    e.stopPropagation();
                    buttonProps.onClick?.(e);
                }}
                icon={icon ?? <SearchOutlined />}
                style={{
                    backgroundColor: condensed ? undefined : colors.darkPurple,
                    borderColor: condensed ? undefined : colors.darkPurple,
                    borderRadius: condensed && !compact ? '4px' : undefined,
                    marginLeft: 'auto',
                    ...buttonProps.style,
                }}
            >
                {!compact && (title ?? 'Search Customer')}
            </HollowButton>
        </ConditionalWrapper>
    );
};

export default SearchCustomerButton;
